import { storageGet, storageSet, storageRemove } from '../platform/storage';

const SESSION_KEY = 'v2_session';

export async function getCachedSession() {
  return storageGet(SESSION_KEY);
}

export async function saveSession(session) {
  await storageSet(SESSION_KEY, session);
}

export async function clearSession() {
  await storageRemove(SESSION_KEY);
}
